import React from 'react';
export function ScienceSection() {
  return <section className="bg-white py-20" data-id="element-177">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row md:items-stretch items-center gap-12" data-id="element-178">
        <div className="w-full md:w-1/2 flex" data-id="element-179">
          <img src="https://cdn.magicpatterns.com/uploads/7TdiyMcMF9tvy5SXGXKobN/ChatGPT_Image_22_may_2026,_09_48_55_p.m..png" alt="Mujer despierta en la cama mirando su teléfono de noche" className="w-full h-full max-h-[700px] rounded-2xl shadow-xl object-cover" data-id="element-180" />
        </div>

        <div className="w-full md:w-1/2 space-y-8" data-id="element-181">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-text" data-id="element-182">
            La ciencia detrás del sueño roto
          </h2>

          <div className="space-y-4 text-lg text-gray" data-id="element-183">
            <p className="font-bold text-text" data-id="element-184">
              Tu problema no es insomnio. Es cortisol nocturno elevado.
            </p>
            <p data-id="element-185">
              Cuando el cortisol no baja de noche, tu cerebro no puede entrar en
              sueño profundo — sin importar cuántas horas estés en cama.
            </p>
            <p data-id="element-186">
              El Código del Sueño Profundo ataca la causa raíz: regula el
              cortisol, sincroniza tu ritmo circadiano y prepara tu sistema
              nervioso para descansar de verdad.
            </p>
          </div>

          <div className="space-y-4 pt-4" data-id="element-187">
            <div className="bg-accent/20 p-5 rounded-xl border border-accent/30" data-id="element-188">
              <p className="font-medium text-secondary" data-id="element-189">
                <span className="mr-2" data-id="element-190">🔬</span> El cortisol elevado de noche
                reduce el sueño profundo hasta un 40%
              </p>
            </div>
            <div className="bg-accent/20 p-5 rounded-xl border border-accent/30" data-id="element-191">
              <p className="font-medium text-secondary" data-id="element-192">
                <span className="mr-2" data-id="element-193">🌙</span> La luz azul suprime la
                melatonina hasta un 50% en adultos
              </p>
            </div>
            <div className="bg-accent/20 p-5 rounded-xl border border-accent/30" data-id="element-194">
              <p className="font-medium text-secondary" data-id="element-195">
                <span className="mr-2" data-id="element-196">⏰</span> Un horario consistente
                sincroniza el ritmo circadiano en solo 7 días
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}